module.exports = __webpack_public_path__ + "static/media/Enmascarar grupo 10@2x.5f0c8f85.png";